import { Box, Typography } from "@mui/material";
import { useAxios } from "../../contexts/axios.context";
import { useCallback, useEffect } from "react";

const NotFound = () => {
    const { get } = useAxios();

    const getServerNotFoundStatus = useCallback(async () => {
        try {
            await get("/404");
        } catch (error) {
            console.error(error);
        }
    }, [get]);
    useEffect(() => {
        getServerNotFoundStatus();
    }, [getServerNotFoundStatus]);
    return (
        <Box justifyContent="center" alignItems="center" display="flex" minHeight="60vh" flexDirection="column">
            <Typography variant="h1">404</Typography>
            <Typography variant="body1">Oops, Page not found</Typography>
            <Typography variant="caption">website content has been removed or moved to another URL</Typography>
        </Box>
    );
};

export default NotFound;
